import { Component, Input } from "@angular/core"
import { PremiumColors } from "../../../models/collection/premiumColors.model"
import { WindowSizeService } from "../../../services/window-size.service"
import Utils from "../../../utils/utils"

@Component({
    selector: "app-search-bar",
    templateUrl: "./search-bar.component.html",
    styleUrls: ["./search-bar.component.scss"],
    standalone: false,
})
export class SearchBarComponent {
    @Input() logo: string = ""
    @Input() collectionSlug: string = ""
    @Input() collectionTitle: string = ""
    @Input() colors: PremiumColors = new PremiumColors({})
    @Input() disabled: boolean = false
    urlSegments: string[] = []

    constructor(public windowSize: WindowSizeService) {}

    ngOnInit() {
        this.setURLSegments()
    }

    private setURLSegments() {
        this.urlSegments = ["/collection", this.collectionSlug]
        Utils.isPreviewMode() && this.urlSegments.push("preview")
    }
}
